import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    position: 'relative',
    display: 'flex',
    flexDirection: (props) => (props.variant === 'passFail' ? 'row' : 'column'),
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dropSelect: {
    position: 'absolute',
    zIndex: 100,
  },
  btn: {
    width: '100%',
    backgroundColor: theme.palette.action.disabledBackground,
    borderRadius: 10,
    borderLeftWidth: 5,
    borderColor: 'red',
    borderLeftStyle: 'solid',
    marginBottom: 1,
    textAlign: 'left',
    minHeight: 50,
    marginRight: (props) => (props.variant === 'passFail' ? 5 : 0),

    '& .MuiButton-label': {
      justifyContent: 'flex-start',
      fontWeight: 'normal',
    },
  },
  btnSelected: {},
  btnText: {
    fontWeight: 'normal',
    fontSize: 12,
  },
  optNumber: {
    fontWeight: 'bold',
    fontSize: 15,
    marginRight: 10,
  },
  icon: {
    marginRight: 5,
  },
}));

export default useStyles;
